import { Box, Alert, Typography, MenuItem } from '@mui/material'
import { Input } from 'pages/user-profile/userProfileStylesMui'
import { RouteProps } from 'routes/AppRouter'
import genericStyle from '../../common/utils/generic.module.css'
import { useTranslation } from 'react-i18next'
import React, { ChangeEvent, useState } from 'react'
import styles from './ExternalRegister.module.css'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { emptyUserDTO, UserDTO } from '../../modules/users/models/User'
import { UserTreatmentWithTreatmentNameDTO } from 'modules/treatments/models/UserTreatmentWithTreatmentNameDTO'
import { UserGender } from 'modules/users/enums/UserGender'
import { LangType } from 'common/enums/LangType'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { CalendarIcon } from 'features/calendar/Calendar'
import dayjs from 'dayjs'
import { getNotificationContainer } from 'container/notification-module'
import { EXTERNAL_INVITATION_SERVICE_KEY } from 'modules/notifications'
import { IExternalInvitationService } from 'modules/notifications/services/ExternalInvitationService'
import { useSnackbar } from 'notistack'
import { ROUTE_LOGIN } from 'routes/routes-constants'

interface CreateProfesionalProps extends RouteProps {
  token: string
}

export interface Schedule extends UserTreatmentWithTreatmentNameDTO {
  frequency: string
}

const notificationContainer = getNotificationContainer()
const externalInvitationService = notificationContainer.get<IExternalInvitationService>(
  EXTERNAL_INVITATION_SERVICE_KEY
)

export const Editor = (props: CreateProfesionalProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const [message, setMessage] = useState<string>('')
  const [isDatePickerOpen, setIsDatePickerOpen] = useState<boolean>(false)
  const [newProfessional, setNewProfessional] = useState<UserDTO>(emptyUserDTO())
  const [newProfessionalPassword, setNewProfessionalPassword] = useState<string>('')

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault()
    externalInvitationService
      .registerUser(newProfessional, props.token, newProfessionalPassword)
      .subscribe({
        next: () => {
          enqueueSnackbar(t('changesWereSaved'), { variant: 'success' })
          navigate(ROUTE_LOGIN)
        },
        error: () => {
          enqueueSnackbar(t('anErrorOccured'), { variant: 'error' })
        },
      })
  }

  const handleDateChange = (date: dayjs.Dayjs | null) => {
    setNewProfessional({
      ...newProfessional,
      dob: date ? date.toDate() : new Date(), // Convierte dayjs → Date (o null)
    })
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setNewProfessional(Object.assign({ ...newProfessional }, { [e.target.name]: e.target.value }))

  return (
    <Box className={styles.parentContainer}>
      <Box className={`${genericStyle.container} ${styles.container}`}>
        <form className={styles.form} id={'editUser'} onSubmit={handleSave}>
          <Box width={'100%'} display={'flex'} bgcolor="transparent" m="1rem">
            <Box
              display={'flex'}
              flexGrow={1}
              id={'Seccion Derecha'}
              flexDirection={'column'}
              justifyContent={'space-between'}
            >
              <Box id={'Professional Form'}>
                <Box style={{ maxWidth: '100%' }} className={styles.headerContainer}>
                  <Typography className={styles.headerTitle}>{t('professionalData')}</Typography>
                </Box>
                <Box mb={1} className={styles.textFieldBox}>
                  <Box marginRight={'20px'} width={'50%'}>
                    <Typography className={styles.inputTitle}>{t('name')}</Typography>
                    <Input
                      id={'firstName'}
                      key={'firstName'}
                      name="firstName"
                      className={styles.textField}
                      value={newProfessional.firstName}
                      type="text"
                      required
                      variant={'outlined'}
                      size={'small'}
                      onChange={handleChange}
                    />
                  </Box>
                  <Box marginRight={'20px'} width={'50%'}>
                    <Typography className={styles.inputTitle}>{t('lastName')}</Typography>
                    <Input
                      id={'lastName'}
                      label={''}
                      key={'lastName'}
                      name="lastName"
                      className={styles.textField}
                      value={newProfessional.lastName}
                      type="text"
                      required
                      variant={'outlined'}
                      size={'small'}
                      onChange={handleChange}
                    />
                  </Box>
                </Box>
                <Box mb={1} className={styles.textFieldBox}>
                  <Box marginRight={'20px'} width={'50%'}>
                    <Typography className={styles.inputTitle}>{t('gender')}</Typography>
                    <Input
                      select
                      variant={'outlined'}
                      sx={{ width: '100%' }}
                      id="gender"
                      name={'gender'}
                      value={newProfessional.gender || UserGender.Male}
                      label={''}
                      onChange={handleChange}
                      required
                    >
                      <MenuItem value={UserGender.Male}>{t('male')}</MenuItem>
                      <MenuItem value={UserGender.Female}>{t('female')}</MenuItem>
                    </Input>
                  </Box>
                  <Box marginRight={'20px'} width={'50%'}>
                    <Typography className={styles.inputTitle}>{t('language')}</Typography>
                    <Input
                      select
                      variant={'outlined'}
                      sx={{ width: '100%' }}
                      id="language"
                      name={'language'}
                      value={newProfessional.language}
                      label={''}
                      onChange={handleChange}
                      required
                    >
                      <MenuItem value={LangType.Spanish}>{t('spanish')}</MenuItem>
                      <MenuItem value={LangType.English}>{t('english')}</MenuItem>
                      <MenuItem value={LangType.Italian}>{t('italian')}</MenuItem>
                    </Input>
                  </Box>
                </Box>
                <Box mb={1} className={styles.textFieldBox}>
                  <Box marginRight={'20px'} width={'50%'}>
                    <Typography className={styles.inputTitle}>{t('Password')}</Typography>
                    <Input
                      fullWidth
                      id={'currentPass'}
                      label={''}
                      key={'currentPass'}
                      required
                      name="currentPass"
                      className={styles.textFieldPass}
                      type="password"
                      value={newProfessionalPassword}
                      onChange={(e) => setNewProfessionalPassword(e.target.value)}
                      variant={'outlined'}
                      size={'small'}
                    />
                  </Box>
                  <Box marginRight={'20px'} width={'50%'}>
                    <Typography className={styles.inputTitle}>{t('phone')}</Typography>
                    <Input
                      id={'phone'}
                      label={''}
                      key={'phone'}
                      name="phone"
                      className={styles.textField}
                      value={newProfessional.phone}
                      type="phone"
                      required
                      variant={'outlined'}
                      size={'small'}
                      onChange={handleChange}
                    />
                  </Box>
                </Box>
                <Box mb={1} className={styles.textFieldBox}>
                  <Box marginRight={'20px'} width={'50%'}>
                    <Typography className={styles.inputTitle}>{t('dob')}</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es'}>
                      <DatePicker
                        open={isDatePickerOpen}
                        onOpen={() => setIsDatePickerOpen(true)}
                        onClose={() => setIsDatePickerOpen(false)}
                        key={'finishDate'}
                        format={'DD/MM/YYYY'}
                        onChange={handleDateChange}
                        label={''}
                        value={newProfessional.dob ? dayjs(newProfessional.dob) : null}
                        slotProps={{
                          textField: {
                            id: 'finishDate',
                            size: 'small',
                            InputProps: {
                              sx: {
                                '& fieldset': {
                                  borderRadius: 32,
                                  border: '1px solid #E8E7EC',
                                  fontFamily: 'Montserrat',
                                  fontSize: '13px',
                                },
                                '& .MuiInputBase-root': {
                                  fontFamily: 'Montserrat',
                                  fontSize: '13px',
                                },
                                '& .MuiOutlinedInput-root': {
                                  border: 'none',
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#2E7161',
                                  },
                                },
                              },
                              onClick: () => setIsDatePickerOpen(true),
                            },
                          },
                        }}
                        slots={{
                          openPickerIcon: CalendarIcon,
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
                <Box id={'Form y Buttons'} display="flex" justifyContent={'flex-end'} mb={4}>
                  <Box
                    className={styles.buttonContainer}
                    display="flex"
                    paddingLeft="40px"
                    paddingBottom="5px"
                  >
                    <Button className={styles.buttonSubmit} type={'submit'}>
                      {t('save')}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </form>
        {message && (
          <Box mb={3}>
            <Alert className={styles.message} severity="success" key="message" id="message">
              {t(message)}
            </Alert>
          </Box>
        )}
      </Box>
    </Box>
  )
}
